import { Box, Button, CircularProgress, Tooltip } from '@mui/material';
import Iconify from '../iconify';

export default function UploadButton({ label, sublabel, accept, loading, inputRef, onChange }) {
  return (
    <Box>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        style={{ display: 'none' }}
        onChange={onChange}
      />
      <Tooltip title={sublabel}>
        <Button
          fullWidth size="small" variant="outlined" color="inherit"
          startIcon={loading ? <CircularProgress size={14} /> : <Iconify icon="eva:upload-fill" />}
          onClick={() => inputRef.current?.click()}
          disabled={loading}
          sx={{ justifyContent: 'flex-start', fontSize: 12 }}
        >
          {label}
        </Button>
      </Tooltip>
    </Box>
  );
}
